import { CHAT_RESUME_ACTION, CHAT_START_NEW_ACTION } from './messageTemplates'

export const greetingTemplate = {
  $schema: 'http://adaptivecards.io/schemas/adaptive-card.json',
  type: 'AdaptiveCard',
  version: '1.4',
  body: [
    {

          type: 'ColumnSet',
          horizontalAlignment: 'center',
          columns: [
            {
              $data: '${greetings}',
              type: 'Column',
              width: 'stretch',
              items: [
                {
                  type: 'Container',
                  style: 'default',
                  bleed: true,
                  horizontalAlignment: 'center',
                  height: "stretch",
                  items: [
                    {
                      type: 'Image',
                      url: '${icon}',
                      size: 'medium',
                      spacing: 'small',
                      horizontalAlignment: 'center',
                    },
                    {
                      type: 'TextBlock',
                      text: '${title}',
                      weight: 'bolder',
                      size: 'medium',
                      wrap: true,
                      horizontalAlignment: 'center',
                      spacing: 'medium',
                    },
                    {
                      type: 'TextBlock',
                      text: '${description}',
                      wrap: true,
                      isSubtle: true,
                      horizontalAlignment: 'center',
                      spacing: 'small',
                    },
                  ],
                  selectAction: {
                    type: 'Action.Submit',
                    data: {
                      action: '${action}',
                    },
                  },
                },
              ],
            },
      ],
    },
  ],
}

export const greetingData = {
  greetings: [
    {
      icon: '../../img/turtle1.png',
      title: 'Start a New Chat',
      description: 'Begin a fresh conversation with the assistant.',
      action: CHAT_START_NEW_ACTION,
    },
    {
      icon: '../../img/turtle2.png',
      title: 'Resume Previous Chat',
      description: 'Continue where you left off earlier.',
      action: CHAT_RESUME_ACTION,
    },
    {
      icon: '../../img/turtle3.png',
      title: 'Explore Templates',
      description: 'Choose from predefined conversation templates.',
      action: 'browse_templates',
    },
  ],
}
